'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _contract_jsons = require('../contract_jsons');

var _contract_jsons2 = _interopRequireDefault(_contract_jsons);

var _genesis_contract_wrapper = require('./genesis_contract_wrapper');

var _genesis_contract_wrapper2 = _interopRequireDefault(_genesis_contract_wrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
Copyright: Ambrosus Inc.
Email: tech@ambrosus.io

This Source Code Form is subject to the terms of the Mozilla Public License, v. 2.0. If a copy of the MPL was not distributed with this file, You can obtain one at https://mozilla.org/MPL/2.0/.

This Source Code Form is “Incompatible With Secondary Licenses”, as defined by the Mozilla Public License, v. 2.0.
*/

var MultiplexerWrapper = function (_GenesisContractWrapp) {
  (0, _inherits3.default)(MultiplexerWrapper, _GenesisContractWrapp);

  function MultiplexerWrapper(multiplexerContractAddress, web3, defaultAddress) {
    (0, _classCallCheck3.default)(this, MultiplexerWrapper);
    return (0, _possibleConstructorReturn3.default)(this, (MultiplexerWrapper.__proto__ || Object.getPrototypeOf(MultiplexerWrapper)).call(this, multiplexerContractAddress, _contract_jsons2.default.multiplexer, web3, defaultAddress));
  }

  (0, _createClass3.default)(MultiplexerWrapper, [{
    key: 'transferOwnership',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(newOwnerAddress) {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt('return', this.contract.methods.transferOwnership(newOwnerAddress).encodeABI());

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function transferOwnership(_x) {
        return _ref.apply(this, arguments);
      }

      return transferOwnership;
    }()
  }, {
    key: 'transferContractsOwnership',
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(address) {
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt('return', this.contract.methods.transferContractsOwnership(address).encodeABI());

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function transferContractsOwnership(_x2) {
        return _ref2.apply(this, arguments);
      }

      return transferContractsOwnership;
    }()
  }, {
    key: 'changeContext',
    value: function () {
      var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(contextAddress) {
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt('return', this.contract.methods.changeContext(contextAddress).encodeABI());

              case 1:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function changeContext(_x3) {
        return _ref3.apply(this, arguments);
      }

      return changeContext;
    }()
  }, {
    key: 'addToWhitelist',
    value: function () {
      var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(candidateAddress, role, deposit) {
        return _regenerator2.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt('return', this.contract.methods.addToWhitelist(candidateAddress, role, deposit).encodeABI());

              case 1:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function addToWhitelist(_x4, _x5, _x6) {
        return _ref4.apply(this, arguments);
      }

      return addToWhitelist;
    }()
  }, {
    key: 'removeFromWhitelist',
    value: function () {
      var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5(candidateAddress) {
        return _regenerator2.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt('return', this.contract.methods.removeFromWhitelist(candidateAddress).encodeABI());

              case 1:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function removeFromWhitelist(_x7) {
        return _ref5.apply(this, arguments);
      }

      return removeFromWhitelist;
    }()
  }, {
    key: 'retireApollo',
    value: function () {
      var _ref6 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6(apolloAddress) {
        return _regenerator2.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.abrupt('return', this.contract.methods.retireApollo(apolloAddress).encodeABI());

              case 1:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function retireApollo(_x8) {
        return _ref6.apply(this, arguments);
      }

      return retireApollo;
    }()
  }, {
    key: 'setBaseUploadFee',
    value: function () {
      var _ref7 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee7(fee) {
        return _regenerator2.default.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                return _context7.abrupt('return', this.contract.methods.setBaseUploadFee(fee).encodeABI());

              case 1:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function setBaseUploadFee(_x9) {
        return _ref7.apply(this, arguments);
      }

      return setBaseUploadFee;
    }()
  }, {
    key: 'transferOwnershipForValidatorSet',
    value: function () {
      var _ref8 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee8(address) {
        return _regenerator2.default.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                return _context8.abrupt('return', this.contract.methods.transferOwnershipForValidatorSet(address).encodeABI());

              case 1:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function transferOwnershipForValidatorSet(_x10) {
        return _ref8.apply(this, arguments);
      }

      return transferOwnershipForValidatorSet;
    }()
  }, {
    key: 'transferOwnershipForBlockRewards',
    value: function () {
      var _ref9 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee9(address) {
        return _regenerator2.default.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                return _context9.abrupt('return', this.contract.methods.transferOwnershipForBlockRewards(address).encodeABI());

              case 1:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function transferOwnershipForBlockRewards(_x11) {
        return _ref9.apply(this, arguments);
      }

      return transferOwnershipForBlockRewards;
    }()
  }, {
    key: 'setBaseReward',
    value: function () {
      var _ref10 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee10(newBaseReward) {
        return _regenerator2.default.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                return _context10.abrupt('return', this.contract.methods.setBaseReward(newBaseReward).encodeABI());

              case 1:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function setBaseReward(_x12) {
        return _ref10.apply(this, arguments);
      }

      return setBaseReward;
    }()
  }, {
    key: 'setDeveloper',
    value: function () {
      var _ref11 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee11(developer) {
        return _regenerator2.default.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                return _context11.abrupt('return', this.contract.methods.setDeveloper(developer).encodeABI());

              case 1:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function setDeveloper(_x13) {
        return _ref11.apply(this, arguments);
      }

      return setDeveloper;
    }()
  }, {
    key: 'setDeveloperFee',
    value: function () {
      var _ref12 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee12(developerFee) {
        return _regenerator2.default.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                return _context12.abrupt('return', this.contract.methods.setDeveloperFee(developerFee).encodeABI());

              case 1:
              case 'end':
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function setDeveloperFee(_x14) {
        return _ref12.apply(this, arguments);
      }

      return setDeveloperFee;
    }()
  }, {
    key: 'setSupportFee',
    value: function () {
      var _ref13 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee13(support, fee) {
        return _regenerator2.default.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                return _context13.abrupt('return', this.contract.methods.setSupportFee(support, fee).encodeABI());

              case 1:
              case 'end':
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function setSupportFee(_x15, _x16) {
        return _ref13.apply(this, arguments);
      }

      return setSupportFee;
    }()
  }, {
    key: 'addAdmin',
    value: function () {
      var _ref14 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee14(admin) {
        return _regenerator2.default.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                return _context14.abrupt('return', this.contract.methods.addAdmin(admin).encodeABI());

              case 1:
              case 'end':
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function addAdmin(_x17) {
        return _ref14.apply(this, arguments);
      }

      return addAdmin;
    }()
  }, {
    key: 'removeAdmin',
    value: function () {
      var _ref15 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee15(admin) {
        return _regenerator2.default.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                return _context15.abrupt('return', this.contract.methods.removeAdmin(admin).encodeABI());

              case 1:
              case 'end':
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function removeAdmin(_x18) {
        return _ref15.apply(this, arguments);
      }

      return removeAdmin;
    }()
  }, {
    key: 'addPool',
    value: function () {
      var _ref16 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee16(pool) {
        return _regenerator2.default.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                return _context16.abrupt('return', this.contract.methods.addPool(pool).encodeABI());

              case 1:
              case 'end':
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));

      function addPool(_x19) {
        return _ref16.apply(this, arguments);
      }

      return addPool;
    }()
  }, {
    key: 'removePool',
    value: function () {
      var _ref17 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee17(pool) {
        return _regenerator2.default.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                return _context17.abrupt('return', this.contract.methods.removePool(pool).encodeABI());

              case 1:
              case 'end':
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));

      function removePool(_x20) {
        return _ref17.apply(this, arguments);
      }

      return removePool;
    }()
  }, {
    key: 'setUserRoles',
    value: function () {
      var _ref18 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee18(roleHexes, userAddress) {
        return _regenerator2.default.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                return _context18.abrupt('return', this.contract.methods.setUserRoles(userAddress, roleHexes).encodeABI());

              case 1:
              case 'end':
                return _context18.stop();
            }
          }
        }, _callee18, this);
      }));

      function setUserRoles(_x21, _x22) {
        return _ref18.apply(this, arguments);
      }

      return setUserRoles;
    }()
  }, {
    key: 'setRole',
    value: function () {
      var _ref19 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee19(roleName, trueSelectors, falseSelectors) {
        return _regenerator2.default.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                return _context19.abrupt('return', this.contract.methods.setRole(roleName, trueSelectors, falseSelectors).encodeABI());

              case 1:
              case 'end':
                return _context19.stop();
            }
          }
        }, _callee19, this);
      }));

      function setRole(_x23, _x24, _x25) {
        return _ref19.apply(this, arguments);
      }

      return setRole;
    }()
  }]);
  return MultiplexerWrapper;
}(_genesis_contract_wrapper2.default);

exports.default = MultiplexerWrapper;